(function () {
  'use strict';
  document.querySelectorAll('.bsc').forEach(function (root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    var rows = Array.from(root.querySelectorAll('tbody tr'));
    var search = root.querySelector('[data-search]');
    var filter = root.querySelector('[data-filter]');
    var values = new Set();
    rows.forEach(function (row) { row.dataset.filterValues.split('||').forEach(function (value) { if (value) values.add(value); }); });
    Array.from(values).sort(function (a, b) { return a.localeCompare(b, undefined, {numeric: true}); }).forEach(function (value) {
      var option = document.createElement('option'); option.value = value; option.textContent = value; filter.appendChild(option);
    });
    function apply() {
      var query = search.value.trim().toLowerCase(); var count = 0;
      rows.forEach(function (row) { var visible = row.dataset.searchText.toLowerCase().includes(query) && (!filter.value || row.dataset.filterValues.split('||').includes(filter.value)); row.hidden = !visible; if (visible) count += 1; });
      root.querySelector('[data-count]').textContent = count + ' products';
      root.querySelector('[data-empty]').hidden = count !== 0;
    }
    var timer;search.addEventListener('input',function(){apply();clearTimeout(timer);timer=setTimeout(function(){if(window.BinamSales)window.BinamSales.emit('catalog_filter_use',{catalog_type:root.dataset.mode,filter_type:'search',query_length:search.value.length});},450);});
    filter.addEventListener('change', function () { apply(); if (window.BinamSales) window.BinamSales.emit('catalog_filter_use', {catalog_type: root.dataset.mode, filter_value: filter.value}); });
    root.querySelector('[data-reset]').addEventListener('click', function () { search.value = ''; filter.value = ''; apply(); });
    root.querySelectorAll('.bsc-order select[name=id]').forEach(function (select) {
      select.addEventListener('change', function () {
        var label = select.options[select.selectedIndex].textContent.split(' — ')[1];
        var cell = select.closest('tr').children[select.closest('tr').children.length - 2];
        if (label) cell.textContent = label;
      });
    });
    apply();
  });
})();

